function NavigationMenu() {
    return (
        <>
            <ul id="nav">
                <li><a href="/">Dashboard</a></li>
                <li><a href="/importexport">Import Export Emails</a></li>
                <li><a href="/uploadvalidate">Email Upload Validated</a></li>
                <li><a href="/createsend">Send Email</a></li>
                <li><a href="/emailtemplates">Email Templates</a></li>
                <li><a href="/cronjobs">CRON Jobs</a></li>
            </ul>
        </>
    );
}

export default NavigationMenu;